import { Router } from '@angular/router';
import { driver, DriveStep } from 'driver.js';

type DriverObj = ReturnType<typeof driver>;

export function getShippingDeliveryEnterpriseSteps(
  router: Router,
  driverObj: DriverObj
): DriveStep[] {
  return [
    {
      element: '#menu-developer-settings',
      popover: {
        title: 'Menu API Key',
        description: 'Untuk menggunakan API Shipping Delivery, pertama dapatkan API key dari menu Developer → API Key',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).executeMenuDevClick();
        }
      },
      onHighlighted: () => {
        (window as any).executeMenuDevClick = () => {
          router.navigate(['/settings']).then(() => {
            let attempts = 0;
            const checkInterval = setInterval(() => {
              attempts++;

              const tabs = document.querySelectorAll('.ant-tabs-tab');
              if (tabs.length > 0) {
                const apiKeyTab = Array.from(tabs).find(t => t.textContent?.toLowerCase().includes('api key')) as HTMLElement || tabs[0] as HTMLElement;
                if (apiKeyTab && !apiKeyTab.classList.contains('ant-tabs-tab-active')) {
                  apiKeyTab.click();
                }
              }

              if (document.querySelector('#api-shipping-delivery') || attempts > 30) {
                clearInterval(checkInterval);
                driverObj.moveNext();
              }
            }, 100);
          });
        };
        const el = document.querySelector('#menu-developer-settings');
        if (el) {
          (window as any).menuDevClickListener = (e: Event) => {
            (window as any).executeMenuDevClick();
          };
          el.addEventListener('click', (window as any).menuDevClickListener);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#menu-developer-settings');
        if (el && (window as any).menuDevClickListener) {
          el.removeEventListener('click', (window as any).menuDevClickListener);
          delete (window as any).menuDevClickListener;
        }
        delete (window as any).executeMenuDevClick;
      }
    },
    {
      element: '#api-shipping-delivery',
      popover: {
        title: 'Tampilkan API Key',
        description: 'Klik tombol show key untuk melihat API key anda.',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).handleShowKeyNextClick();
        }
      },
      onHighlighted: () => {
        const el = document.querySelector('#api-shipping-delivery') as HTMLElement;
        if (el) el.style.pointerEvents = 'none';

        (window as any).executeShowKeyNext = () => {
          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (document.querySelector('.modal-content') || attempts > 30) {
              clearInterval(checkInterval);
              driverObj.moveNext();
            }
          }, 100);
        };

        (window as any).handleShowKeyNextClick = () => {
          if (!document.querySelector('input[formControlName="password"]')) {
            const btn = document.querySelector('#api-shipping-delivery span.underline.cursor-pointer') as HTMLElement;
            if (btn) {
              btn.click();
              return;
            }
          }
          (window as any).executeShowKeyNext();
        };

        const btn = document.querySelector('#api-shipping-delivery span.underline.cursor-pointer') as HTMLElement;
        if (btn) {
          btn.style.pointerEvents = 'auto';
          (window as any).handleShowKeyPhysicalClick = () => {
             (window as any).executeShowKeyNext();
          };
          btn.addEventListener('click', (window as any).handleShowKeyPhysicalClick);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#api-shipping-delivery') as HTMLElement;
        if (el) el.style.pointerEvents = '';
        const btn = document.querySelector('#api-shipping-delivery span.underline.cursor-pointer') as HTMLElement;
        if (btn) {
          btn.style.pointerEvents = '';
          if ((window as any).handleShowKeyPhysicalClick) {
            btn.removeEventListener('click', (window as any).handleShowKeyPhysicalClick);
            delete (window as any).handleShowKeyPhysicalClick;
          }
        }
        delete (window as any).executeShowKeyNext;
        delete (window as any).handleShowKeyNextClick;
      }
    },
    {
      element: '.modal-content',
      popover: {
        title: 'Masukkan Password',
        description: 'Isi password akun anda dan klik tombol <b>Show Key</b>.',
        side: 'bottom',
        align: 'center',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          const passwordInput = document.querySelector('.modal-content input[type="password"], .modal-content input[formControlName="password"]') as HTMLInputElement;
          if (passwordInput && passwordInput.value.trim()) {
            const showKeyBtn = document.querySelector('.modal-content button[type="submit"], .modal-content button.btn-primary') as HTMLElement;
            if (showKeyBtn) showKeyBtn.click();
          }
        }
      },
      onHighlighted: () => {
        const toggleNextBtn = () => {
          const passwordInput = document.querySelector('.modal-content input[type="password"], .modal-content input[formControlName="password"]') as HTMLInputElement;
          const nextBtn = document.querySelector('.driver-popover-next-btn') as HTMLButtonElement;
          if (nextBtn) {
            const hasValue = passwordInput && passwordInput.value.trim().length > 0;
            nextBtn.disabled = !hasValue;
            nextBtn.style.opacity = hasValue ? '1' : '0.5';
            nextBtn.style.cursor = hasValue ? 'pointer' : 'not-allowed';
          }
        };

        toggleNextBtn();

        (window as any).passwordInputHandler = () => toggleNextBtn();
        document.querySelector('.modal-content')?.addEventListener('input', (window as any).passwordInputHandler);

        (window as any).__passwordVerifiedForTour = false;
        (window as any).modalCheckInterval = setInterval(() => {
          if (!document.querySelector('.modal-content')) {
            clearInterval((window as any).modalCheckInterval);
            if ((window as any).__passwordVerifiedForTour) {
              driverObj.moveNext();
            } else {
              driverObj.moveTo(1);
            }
          }
        }, 200);
      },
      onDeselected: () => {
        if ((window as any).modalCheckInterval) {
          clearInterval((window as any).modalCheckInterval);
        }
        if ((window as any).passwordInputHandler) {
          document.querySelector('.modal-content')?.removeEventListener('input', (window as any).passwordInputHandler);
          delete (window as any).passwordInputHandler;
        }
      }
    },
    {
      element: '#api-shipping-delivery',
      popover: {
        title: 'API key Sandbox siap digunakan',
        description: 'Sebelum kita menuju mode live, gunakan base URL dan API key Sandbox untuk testing. petunjuk teknis integrasi bisa <a href="https://rajaongkir.com/docs/delivery-order-api/getting_started/Getting-Started" target="_blank" class="text-primary" style="text-decoration: underline;">dibaca di sini</a>.',
        side: 'bottom',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
      onHighlighted: () => {
        const row = document.querySelector('#api-shipping-delivery') as HTMLElement;
        if (row) {
          const images = row.querySelectorAll('img');
          images.forEach(img => {
            img.style.pointerEvents = 'none';
            img.style.cursor = 'default';
          });
          const keySpan = row.querySelector('td:nth-child(3) span') as HTMLElement;
          if (keySpan) {
            keySpan.style.pointerEvents = 'auto';
          }
        }
      },
      onDeselected: () => {
        const row = document.querySelector('#api-shipping-delivery') as HTMLElement;
        if (row) {
          const images = row.querySelectorAll('img');
          images.forEach(img => {
            img.style.pointerEvents = '';
            img.style.cursor = '';
          });
        }
      }
    },
    {
      element: '.ant-tabs-tab:nth-child(2)',
      popover: {
        title: 'Batasi Akses (Opsional)',
        description: 'Untuk membatasi akses API key pada IP dan platform anda saja agar lebih aman.',
        side: 'bottom',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          const accessTab = document.querySelectorAll('.ant-tabs-tab')[1] as HTMLElement;
          if (accessTab) accessTab.click();

          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (document.querySelector('app-referrer nz-card') || attempts > 30) {
              clearInterval(checkInterval);
              driverObj.moveNext();
            }
          }, 100);
        }
      }
    },
    {
      element: 'app-referrer nz-card',
      popover: {
        title: 'Batasi Akses (Opsional)',
        description: 'Bila list ini dikosongkan, maka secara default akses API key bisa digunakan dari platform manapun.',
        side: 'top',
        align: 'center',
        popoverClass: 'custom-driver-popover text-next-btn'
      },
      onHighlighted: () => {
        const el = document.querySelector('app-referrer nz-card') as HTMLElement;
        if (el) el.style.pointerEvents = 'none';

        if (!(window as any).__tourClickBlockerCard) {
          const blockInteractions = (e: Event) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.driver-popover') && !target.closest('.ant-modal-root') && !target.closest('.ant-modal-wrap') && !target.closest('app-modal-end-tour')) {
              e.stopPropagation();
              e.preventDefault();
            }
          };
          document.addEventListener('click', blockInteractions, true);
          document.addEventListener('mousedown', blockInteractions, true);
          document.addEventListener('keydown', blockInteractions, true);
          (window as any).__tourClickBlockerCard = blockInteractions;
        }
      },
      onDeselected: () => {
        const el = document.querySelector('app-referrer nz-card') as HTMLElement;
        if (el) el.style.pointerEvents = '';

        if ((window as any).__tourClickBlockerCard) {
          document.removeEventListener('click', (window as any).__tourClickBlockerCard, true);
          document.removeEventListener('mousedown', (window as any).__tourClickBlockerCard, true);
          document.removeEventListener('keydown', (window as any).__tourClickBlockerCard, true);
          delete (window as any).__tourClickBlockerCard;
        }
      }
    },
    {
      element: '#menu-document',
      popover: {
        title: 'Dokumen Persyaratan Live',
        description: 'Untuk menggunakan API Shipping Delivery secara live, ada beberapa dokumen yang harus diisi',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).executeMenuDocumentClick();
        }
      },
      onHighlighted: () => {
        (window as any).executeMenuDocumentClick = () => {
          router.navigate(['/account/document']).then(() => {
            let attempts = 0;
            const checkInterval = setInterval(() => {
              attempts++;
              if (document.querySelector('.ant-modal-content') || document.querySelector('app-payment-service-document') || document.querySelector('app-qrisly-service-doc') || document.querySelector('app-shipping-delivery') || attempts > 30) {
                clearInterval(checkInterval);
                driverObj.moveNext();
              }
            }, 100);
          });
        };
        const el = document.querySelector('#menu-document');
        if (el) {
          (window as any).menuDocumentClickListener = (e: Event) => {
            (window as any).executeMenuDocumentClick();
          };
          el.addEventListener('click', (window as any).menuDocumentClickListener);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#menu-document');
        if (el && (window as any).menuDocumentClickListener) {
          el.removeEventListener('click', (window as any).menuDocumentClickListener);
          delete (window as any).menuDocumentClickListener;
        }
        delete (window as any).executeMenuDocumentClick;
      }
    },
    {
      element: '.ant-modal-content',
      popover: {
        title: 'Informasi Dokumen',
        description: 'Pahami informasi dokumen berikut dan klik Continue untuk melanjutkan.',
        side: 'bottom',
        align: 'center',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).handleDocContinueNextClick();
        }
      },
      onHighlighted: () => {
        const hasSeenModal = localStorage.getItem('hasSeenDocInfoModal') === 'true';
        const modalContent = document.querySelector('.ant-modal-content');
        if (hasSeenModal || !modalContent) {
          setTimeout(() => {
            driverObj.moveNext();
          }, 100);
          return;
        }

        (window as any).executeDocContinueNext = () => {
          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (document.querySelector('app-shipping-delivery') || document.querySelector('app-payment-service-document') || attempts > 30) {
              clearInterval(checkInterval);
              driverObj.moveNext();
            }
          }, 100);
        };

        (window as any).handleDocContinueNextClick = () => {
          let clicked = false;
          const buttons = document.querySelectorAll('.ant-modal-content button');
          buttons.forEach(btn => {
            if (btn.textContent && (btn.textContent.includes('Continue') || btn.textContent.includes('Skip for Now'))) {
              (btn as HTMLElement).click();
              clicked = true;
            }
          });
          if (!clicked) (window as any).executeDocContinueNext();
        };

        (window as any).docContinuePhysicalClick = () => {
          (window as any).executeDocContinueNext();
        };

        const buttons = document.querySelectorAll('.ant-modal-content button');
        buttons.forEach(btn => {
          if (btn.textContent && (btn.textContent.includes('Continue') || btn.textContent.includes('Skip for Now'))) {
            btn.addEventListener('click', (window as any).docContinuePhysicalClick);
          }
        });
      },
      onDeselected: () => {
        const buttons = document.querySelectorAll('.ant-modal-content button');
        buttons.forEach(btn => {
          if (btn.textContent && (btn.textContent.includes('Continue') || btn.textContent.includes('Skip for Now')) && (window as any).docContinuePhysicalClick) {
            btn.removeEventListener('click', (window as any).docContinuePhysicalClick);
          }
        });
        delete (window as any).docContinuePhysicalClick;
        delete (window as any).executeDocContinueNext;
        delete (window as any).handleDocContinueNextClick;
      }
    },
    {
      element: 'app-shipping-delivery, app-payment-service-document',
      popover: {
        title: 'Pengisian dan Verifikasi',
        description: 'Setelah mengisi dokumen yang diperlukan, tim RajaOngkir akan memvalidasi dokumennya. Bila tahap ini sudah selesai, API Shipping delivery sudah siap dipakai secara Live!',
        side: 'bottom',
        align: 'center',
        popoverClass: 'custom-driver-popover text-next-btn'
      },
      onHighlighted: () => {
        const el1 = document.querySelector('app-shipping-delivery');
        const el2 = document.querySelector('app-payment-service-document');
        if (el1) (el1 as HTMLElement).style.pointerEvents = 'none';
        if (el2) (el2 as HTMLElement).style.pointerEvents = 'none';

        const refreshHighlight = () => {
          if ((driverObj as any)?.refresh) {
            (driverObj as any).refresh();
          } else {
            window.dispatchEvent(new Event('resize'));
          }
        };

        [50, 150, 300, 500, 1000, 1500].forEach(delay => {
          setTimeout(refreshHighlight, delay);
        });

        const targetEl = el1 || el2;
        if (targetEl && typeof ResizeObserver !== 'undefined') {
          (window as any).__docStepResizeObserver = new ResizeObserver(() => {
            refreshHighlight();
          });
          (window as any).__docStepResizeObserver.observe(targetEl);
        }

        if (!(window as any).__tourClickBlockerDoc) {
          const blockInteractions = (e: Event) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.driver-popover') && !target.closest('.ant-modal-root') && !target.closest('.ant-modal-wrap') && !target.closest('app-modal-end-tour')) {
              e.stopPropagation();
              e.preventDefault();
            }
          };
          document.addEventListener('click', blockInteractions, true);
          document.addEventListener('mousedown', blockInteractions, true);
          document.addEventListener('keydown', blockInteractions, true);
          (window as any).__tourClickBlockerDoc = blockInteractions;
        }
      },
      onDeselected: () => {
        const el1 = document.querySelector('app-shipping-delivery');
        const el2 = document.querySelector('app-payment-service-document');
        if (el1) (el1 as HTMLElement).style.pointerEvents = '';
        if (el2) (el2 as HTMLElement).style.pointerEvents = '';

        if ((window as any).__docStepResizeObserver) {
          (window as any).__docStepResizeObserver.disconnect();
          delete (window as any).__docStepResizeObserver;
        }

        if ((window as any).__tourClickBlockerDoc) {
          document.removeEventListener('click', (window as any).__tourClickBlockerDoc, true);
          document.removeEventListener('mousedown', (window as any).__tourClickBlockerDoc, true);
          document.removeEventListener('keydown', (window as any).__tourClickBlockerDoc, true);
          delete (window as any).__tourClickBlockerDoc;
        }
      }
    },
    {
      element: '#dropdownBasic1',
      popover: {
        title: 'Ganti Mode',
        description: 'Anda bisa mengganti antara mode Sandbox untuk testing dan Live dari sini',
        side: 'bottom',
        align: 'end',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).executeProfilePicNext(true);
        }
      },
      onHighlighted: () => {
        (window as any).executeProfilePicNext = (simulateClick: boolean = false) => {
          if ((window as any).__executingProfilePicNext) return;
          (window as any).__executingProfilePicNext = true;

          // Block click-outside from closing dropdown during transition
          if (!(window as any).__tourClickBlocker) {
            const blockClicks = (e: Event) => {
              const target = e.target as HTMLElement;
              if (!target.closest('#profile-dropdown-container') && !target.closest('.drop-profile') && !target.closest('.driver-popover') && !target.closest('.ant-modal-root') && !target.closest('.ant-modal-wrap') && !target.closest('app-modal-end-tour')) {
                e.stopPropagation();
                e.preventDefault();
              }
            };
            (window as any).__tourClickBlocker = blockClicks;
            document.addEventListener('click', blockClicks, true);
          }

          if (simulateClick) {
            const profilePic = document.querySelector('#dropdownBasic1') as HTMLElement;
            if (profilePic) profilePic.click();
          }

          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            const dropProfile = document.querySelector('.drop-profile');
            if ((dropProfile && dropProfile.classList.contains('show')) || attempts > 30) {
              clearInterval(checkInterval);
              delete (window as any).__executingProfilePicNext;
              setTimeout(() => {
                driverObj.moveNext();
              }, 300);
            }
          }, 100);
        };

        const el = document.querySelector('#dropdownBasic1');
        if (el) {
          (window as any).profilePicClickListener = (e: Event) => {
            (window as any).executeProfilePicNext(false);
          };
          el.addEventListener('click', (window as any).profilePicClickListener);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#dropdownBasic1');
        if (el && (window as any).profilePicClickListener) {
          el.removeEventListener('click', (window as any).profilePicClickListener);
          delete (window as any).profilePicClickListener;
        }
        delete (window as any).executeProfilePicNext;
        delete (window as any).__executingProfilePicNext;
      }
    },
    {
      element: '#profile-dropdown-content',
      popover: {
        title: 'Beralih ke Live Mode',
        description: 'Setelah semua dokumen disetujui, Anda dapat beralih ke mode Live untuk mulai menggunakan layanan secara langsung.',
        side: 'left',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
      onHighlighted: () => {
        const container = document.querySelector('#profile-dropdown-container') as HTMLElement;
        const dropProfile = document.querySelector('.drop-profile') as HTMLElement;
        const dropdownContent = document.querySelector('#profile-dropdown-content') as HTMLElement;

        if (container) {
          container.style.zIndex = '100000';
          container.style.position = 'relative';
          container.style.pointerEvents = 'none';
        }
        if (dropProfile) {
          dropProfile.style.zIndex = '100000';
          dropProfile.classList.add('show');
          dropProfile.style.display = 'block';
          dropProfile.style.pointerEvents = 'none';

          const allChildren = dropProfile.querySelectorAll<HTMLElement>('button, input, a, div, span, img, hr, label');
          allChildren.forEach(child => {
            child.style.pointerEvents = 'none';
            child.style.cursor = 'default';
          });
        }
        if (dropdownContent) {
          dropdownContent.style.pointerEvents = 'none';
        }

        // Add capture-phase click blocker allowing clicks ONLY inside step tooltip .driver-popover or end tour modal
        if (!(window as any).__tourClickBlocker) {
          const blockClicks = (e: Event) => {
            const target = e.target as HTMLElement;
            if (!target.closest('.driver-popover') && !target.closest('.ant-modal-root') && !target.closest('.ant-modal-wrap') && !target.closest('app-modal-end-tour')) {
              e.stopPropagation();
              e.preventDefault();
            }
          };
          document.addEventListener('click', blockClicks, true);
          (window as any).__tourClickBlocker = blockClicks;
        }
      },
      onDeselected: () => {
        if ((window as any).__tourClickBlocker) {
          document.removeEventListener('click', (window as any).__tourClickBlocker, true);
          delete (window as any).__tourClickBlocker;
        }
        const dropProfile = document.querySelector('.drop-profile') as HTMLElement;
        const container = document.querySelector('#profile-dropdown-container') as HTMLElement;
        const dropdownContent = document.querySelector('#profile-dropdown-content') as HTMLElement;
        if (dropProfile) {
          dropProfile.style.zIndex = '';
          dropProfile.style.display = '';
          dropProfile.style.pointerEvents = '';
          const allChildren = dropProfile.querySelectorAll<HTMLElement>('button, input, a, div, span, img, hr, label');
          allChildren.forEach(child => {
            child.style.pointerEvents = '';
            child.style.cursor = '';
          });
        }
        if (container) {
          container.style.zIndex = '';
          container.style.position = '';
          container.style.pointerEvents = '';
        }
        if (dropdownContent) {
          dropdownContent.style.pointerEvents = '';
        }
      }
    }
  ];

}

